import { ptBrCommonFieldsTranslations } from "../common";

export const tickets = {
  name: "Tickets",
  tabs: {
    all: "Todos",
    mine: "Meus",
    unassigned: "Sem atribuição",
    openTickets: "Tickets Abertos",
    open: {
      title: "Abertos",
    },
    closed: {
      title: "Resolvidos",
    },
    search: {
      title: "Buscar",
    },
  },
  buttons: {
    newTicket: "+ Novo Ticket",
    showAll: "Mostrar Todos",
    accept: "Aceitar",
    preview: "Visualizar",
    spy: "Espiar",
  },
  sort: {
    label: "Ordenar por",
    lastActivity: "Última atividade",
    createdDate: "Data de criação",
    priority: "Prioridade",
  },
  contextMenu: {
    changeStatus: "Alterar status",
    changePriority: "Alterar prioridade",
    assignToMe: "Atribuir a mim",
    unassign: "Remover atribuição",
    assignTo: "Atribuir a...",
    transfer: "Transferir...",
    copyLink: "Copiar link",
    openNewTab: "Abrir em nova aba",
    linkCopied: "Link copiado!",
  },
  search: {
    placeholder: "Buscar tickets...",
  },
  queueSelect: {
    placeholder: "Filas",
    allQueues: "Todas",
  },
  unknownContact: "Contato Desconhecido",
  noQueue: "Sem fila",
  status: {
    closed: "resolvido",
  },
  sections: {
    pending: "Pendentes",
    inProgress: "Em andamento",
  },
  filters: {
    search: "Buscar conversas...",
    status: "Status",
    priority: "Prioridade",
    queue: "Fila",
    channel: "Canal",
    advancedFilters: "Filtros Avançados",
    activeFilters: "filtro ativo |||| filtros ativos",
    clearAll: "Limpar filtros",
  },
  actions: {
    createConversation: "Nova Conversa",
    createTicket: "Criar Ticket",
    assignTicket: "Atribuir",
    transferTicket: "Transferir",
    closeTicket: "Resolver Ticket",
    resolveTicket: "Resolver",
    reopenTicket: "Reabrir",
    markAsRead: "Marcar como lida",
    toggleDetails: "Alternar detalhes",
  },
  details: {
    title: "Detalhes",
    contactInfo: "Informações do Contato",
    userInfo: "Informações do Usuário",
    ticketInfo: "Informações do Ticket",
    noTicket: "Nenhum ticket ativo",
    quickActions: "Ações Rápidas",
    actionsComingSoon: "Ações rápidas em breve...",
  },
  empty: {
    title: "Nenhuma conversa selecionada",
    subtitle: "Selecione uma conversa da lista para começar",
    noConversations: "Nenhuma conversa encontrada",
    noConversationsSubtitle: "Ajuste os filtros ou crie uma nova conversa",
  },
  typing: "%{name} está digitando...",
  unread: "%{count} não lida |||| %{count} não lidas",
  list: {
    assignedHeader: "Atribuídos",
    pendingHeader: "Pendentes",
    closedHeader: "Resolvidos",
    allHeader: "Todos os Tickets",
    noTicketsTitle: "Nenhum ticket encontrado",
    noTicketsMessage: "Todos os tickets foram atendidos ou não há tickets correspondentes aos seus filtros.",
  },
  settings: {
    title: "Configurações de Ticket",
    error: {
      load: "Falha ao carregar configurações",
      save: "Falha ao salvar configurações",
    },
    success: {
      saved: "Configurações salvas com sucesso",
    },
    autoReopen: {
      title: "Tempo de Reabertura Automática",
      description: "Quando um cliente envia uma mensagem para um ticket fechado dentro desta janela de tempo, o ticket será reaberto em vez de criar um novo. Defina como 0 para sempre criar novos tickets.",
      disabled: "Desabilitado (sempre criar novo ticket)",
      minutes: "%{minutes} minutos",
      hours: "%{hours} hora(s)",
      hoursAndMinutes: "%{hours}h %{minutes}m",
      unit: "min",
      hint: {
        disabled: "Novas mensagens de clientes sempre criarão um novo ticket.",
        enabled: "Tickets fechados serão reabertos se um cliente enviar uma mensagem dentro de %{time}.",
      },
    },
  },
};

export const ticket = {
  name: "Ticket |||| Tickets",
  fields: {
    id: "ID do Ticket",
    subject: "Assunto",
    status: "Status",
    priority: "Prioridade",
    assignedTo: "Atribuído a",
    assignedUserId: "Atribuído a",
    assignedUser: "Responsável",
    assignee: "Responsável",
    queue: "Fila",
    queueId: "Fila",
    ticketQueue: "Fila",
    conversation: "Conversa",
    conversationId: "Conversa",
    resolvedAt: "Resolvido em",
    closedAt: "Resolvido em",
    firstResponseAt: "Primeira resposta em",
    tags: "Tags",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  status: {
    PENDING: "Pendente",
    OPEN: "Aberto",
    IN_PROGRESS: "Em Andamento",
    WAITING_CUSTOMER: "Aguardando Cliente",
    WAITING_THIRD_PARTY: "Aguardando Terceiro",
    RESOLVED: "Resolvido",
    CLOSED: "Resolvido",
    pending: "Pendente",
    open: "Aberto",
    in_progress: "Em Andamento",
    waiting_customer: "Aguardando Cliente",
    waiting_third_party: "Aguardando Terceiro",
    resolved: "Resolvido",
    closed: "Resolvido",
  },
  statusDescription: {
    pending: "Ticket pendente, aguardando atribuição",
    open: "Ticket aberto e aguardando atendimento",
    resolved: "Ticket resolvido, aguardando fechamento",
    closed: "Ticket resolvido e finalizado",
  },
  search: {
    placeholder: "Buscar tickets...",
  },
  queue: {
    none: "Sem fila",
    default: "Fila padrão",
    noQueues: "Nenhuma fila disponível",
  },
  priority: {
    label: "Prioridade",
    none: "Sem prioridade",
    noneDescription: "Nenhuma prioridade definida",
    LOW: "Baixa",
    MEDIUM: "Média",
    HIGH: "Alta",
    URGENT: "Urgente",
    low: "Baixa",
    medium: "Média",
    high: "Alta",
    urgent: "Urgente",
  },
  priorityDescription: {
    low: "Pode ser resolvido em até 72 horas",
    medium: "Deve ser resolvido em até 24 horas",
    high: "Requer atenção imediata, resolver em até 4 horas",
    urgent: "Crítico! Resolver o mais rápido possível",
  },
  tabs: {
    chat: "Chat",
    details: "Detalhes",
  },
  details: {
    title: "Detalhes do Ticket",
    id: "ID do Ticket",
    priority: "Prioridade",
    status: "Status",
    created: "Criado em",
    updated: "Atualizado em",
    assignment: "Atribuição",
    unassigned: "Este ticket não está atribuído",
    assignedTo: "Atribuído a",
    queue: "Fila",
    noQueue: "Sem fila",
    contact: "Contato",
    noContact: "Sem informações de contato",
    conversation: "Conversa",
    timeline: "Linha do tempo",
    firstResponse: "Primeira resposta",
    resolvedAt: "Resolvido em",
    closedAt: "Resolvido em",
  },
  actions: {
    assign: "Atribuir",
    assignToMe: "Atribuir a mim",
    unassign: "Remover atribuição",
    changeStatus: "Alterar status",
    changePriority: "Alterar prioridade",
    close: "Resolver ticket",
    reopen: "Reabrir ticket",
    resolve: "Resolver ticket",
    viewConversation: "Ver conversa",
    returnToPending: "Devolver para Pendentes",
    transfer: "Transferir",
  },
  empty: {
    title: "Nenhum ticket",
    subtitle: "Ainda não há tickets para exibir.",
  },
  filters: {
    status: "Status",
    priority: "Prioridade",
    assignedTo: "Atribuído a",
    queue: "Fila",
    unassigned: "Não atribuídos",
  },
  noTicket: "Sem ticket",
  viewDetails: "Ver detalhes do ticket",
  unassigned: "Não atribuído",
  noQueue: "Sem fila",
  timestamps: "Datas",
  assignee: "Responsável",
  createdAt: "Criado em",
  statusSelect: {
    current: "Atual",
    confirmTitle: "Confirmar alteração de status",
    confirmCloseMessage: "Tem certeza que deseja resolver este ticket? Esta ação não pode ser desfeita facilmente.",
    confirmClose: "Resolver Ticket",
  },
  assigneeSelect: {
    placeholder: "Buscar usuários...",
    noUsers: "Nenhum usuário encontrado",
    unassign: "Remover atribuição",
    open: "Mostrar usuários",
    close: "Fechar",
  },
  notifications: {
    existingTicketOpened: "Já existe um ticket aberto para este contato. Redirecionando...",
    closed: "Ticket resolvido com sucesso",
    closeFailed: "Erro ao resolver ticket",
    reopened: "Ticket reaberto com sucesso",
    reopenFailed: "Erro ao reabrir ticket",
    reopenBlockedByActiveTicket: "Não é possível reabrir: contato já possui ticket ativo (#%{ticketId})",
    returnedToPending: "Ticket devolvido para pendentes",
    returnFailed: "Erro ao devolver ticket",
    transferred: "Ticket transferido com sucesso",
    transferFailed: "Erro ao transferir ticket",
    spyMode: "Visualização em modo espião ativada",
    spyFailed: "Erro ao ativar modo espião",
    fetchFailed: "Erro ao buscar tickets",
  },
  dialogs: {
    edit: {
      helperText: {
        assignedUser: "Reatribuir para um membro diferente da equipe",
      },
    },
    transfer: {
      title: "Transferir Ticket",
      type: "Tipo de Transferência",
      toUser: "Para Usuário",
      toQueue: "Para Fila",
      selectUser: "Selecionar Usuário",
      selectQueue: "Selecionar Fila",
    },
  },
};
